export default user => `@${user.getFullName()} `;
